import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { createPinia } from "pinia";
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { Translations } from '@aiods/vue';
import Vue3Toastify from 'vue3-toastify';
import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/aura-light-green/theme.css'
import 'vue3-toastify/dist/index.css';
import 'primeicons/primeicons.css'
import '../css/custom.css';
import '../css/app.css';
import * as Sentry from "@sentry/vue";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import i18n from "./i18n";
import { useLanguageStore } from "./Stores/useLanguageStore";

createInertiaApp({
  title: (title) => title,
  progress: {
    color: "#712891",
  },
  resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
  setup({ el, App, props, plugin }) {
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate);

    const _app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(pinia)
      .use(i18n)
      .use(Vue3Toastify,
        {
          // theme: "colored",
          // position: "top-right",
          autoClose: 6000,
        })
      .use(PrimeVue)
      .use(Translations)
      // .use(LucideIcons)
      // .use(Dropdown)
      .mixin({
        methods: {
          route,
        },
        computed: {
          currentUrl: () => window.location.href,
          currentPathname: () => (new URL(window.location.href)).pathname,
        },
        mounted() {

        },
      });

    Sentry.init({
      app: _app,
      dsn: "https://d7564ac20445db9d35b2a1b564acad9f@o4508845094666241.ingest.de.sentry.io/4508845127106640",
      integrations: [
        // Sentry.browserTracingIntegration({ router }),
        Sentry.browserSessionIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/cv.iview\.eu/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    // Initialize language from store
    const languageStore = useLanguageStore();
    i18n.global.locale.value = languageStore.currentLanguage;

    _app.mount(el);

    return _app;
  },
}).then(()=>{});
